export const organizationEndpoints = {
    domain: {
        details: {
            api: '/api/solar/partner/domain/me',
            method: 'GET',
            parameter: false
        },
        makeDefault: {
            api: '/api/solar/partner/domain/name/makedefault',
            method: 'POST',
            parameter: true
        },
        addAlternative: {
            api: '/api/solar/partner/domain/name/add',
            method: 'POST',
            parameter: true
        }
    },
    organizationDetails: {
        details: {
            api: '/api/agora/account/domain',
            method: 'GET',
            parameter: false
        },
        edit: {
            api: '/api/agora/account/edit',
            method: 'POST',
            parameter: false
        },
        editAccountInfo: {
            api: '/api/agora/account/admin/accountInfo/edit',
            method: 'POST',
            parameter: false
        },
        editSellerInfo: {
            api: '/api/agora/account/sellerInfo/edit',
            method: 'POST',
            parameter: false
        },
        editBillingInfo: {
            api: '/api/agora/account/admin/billingInfo/edit',
            method: 'POST',
            parameter: false
        },
        editBranding: {
            api: '/api/agora/branding/edit',
            method: 'POST',
            parameter: false
        },
        sendTestEmail: {
            api: '/api/agora/account/smtp/test',
            method: 'POST',
            parameter: true
        },
        hasFinanceUser: {
            api: '/api/agora/credit/check/financeuser',
            method: 'GET',
            parameter: true
        },
        accountAdmList: {
            api: '/api/agora/account/domain/admuser',
            method: 'GET',
            parameter: true
        },
        isUserAccountAdmin: {
            api: '/api/agora/account/check/isadmin',
            method: 'GET',
            parameter: false
        },
        checkIfBuyerOnInvoice: {
            api: '/api/agora/account/domain/isoninvoice',
            method: 'GET',
            parameter: false
        },
        isAvailableForConsumptionVouchers: {
            api: '/api/agora/account/domain/isAvailableForConsumptionVouchers',
            method: 'GET',
            parameter: false
        }
    },
    address: {
        addShippingAddress: {
            api: '/api/agora/account/address/Shipping/add',
            method: 'POST',
            parameter: false
        },
        deleteShippingAddress: {
            api: '/api/agora/account/address/shipping/delete',
            method: 'POST',
            parameter: false
        }
    },
    employees: {
        list: {
            api: '/api/agora/employee',
            method: 'GET',
            parameter: false
        },
        details: {
            api: '/api/agora/employee/details',
            method: 'GET',
            parameter: true
        },
        add: {
            api: '/api/agora/employee/add',
            method: 'POST',
            parameter: false
        },
        edit: {
            api: '/api/agora/employee/edit',
            method: 'POST',
            parameter: false
        },
        delete: {
            api: '/api/agora/employee/delete',
            method: 'POST',
            parameter: false
        },
        roles: {
            api: '/api/agora/configuration/dict/filtered/employee-role-type',
            method: 'POST',
            parameter: false
        },
        addInstructor: {
            api: '/api/agora/employee/instructor/create',
            method: 'POST',
            parameter: false
        }
    },
    certificates: {
        list: {
            api: '/api/solar/partner/certificates',
            method: 'GET',
            parameter: false
        },
        details: {
            api: '/api/solar/partner/certificates/details',
            method: 'GET',
            parameter: true
        },
        detailsBySKU: {
            api: '/api/solar/partner/certificates/details/sku',
            method: 'GET',
            parameter: true
        },
        add: {
            api: '/api/solar/partner/certificates/add',
            method: 'POST',
            parameter: false
        },
        edit: {
            api: '/api/solar/partner/certificates/edit',
            method: 'PUT',
            parameter: true
        },
        delete: {
            api: '/api/solar/partner/certificates/delete',
            method: 'DELETE',
            parameter: false
        },
        validate: {
            api: '/api/solar/partner/certificates/validate',
            method: 'POST',
            parameter: false
        },
        certDictionary: {
            api: '/api/solar/partner/certificates/cert-dictionary',
            method: 'GET',
            parameter: true
        },
        toggleStatus: {
            api: '/api/solar/partner/certificates/toggle-status',
            method: 'POST',
            parameter: false
        }
    },
    invitations: {
        customers: {
            api: '/api/umbrella/account-customers',
            method: 'GET',
            parameter: true
        }
    }
};



// WEBPACK FOOTER //
// ./src/endpoints/organization.endpoints.ts